<div *ngIf="isPending" class="pending-overlay">
  <div [ngClass]="{ container: !sticky, 'sticky-container': sticky }">
    <app-loading-spinner class="spinner" />
  </div>
</div>
<ng-content />
